import { Component, computed, inject, input } from '@angular/core';
import { NgClass } from '@angular/common';
import {
  CoreJssProxyModule,
  TextField,
  type LinkField,
  type RichTextField,
} from '@core/jss-proxy';
import { RichTextWrapperComponent } from '@legacy/common-ui-utility-components';
import { FieldService, GenericLinkDirective } from '@core/jss-utils';
import { TrackLinkDirective } from '@analytics/events';
import type { IconIcon } from '@essent/current-web';
import { CrntButtonAlt } from '@essent/current-web-angular';

import { ExtendedUspComponent } from '../extended-usp/extended-usp.component';

export type ExtentedUsp = {
  icon: IconIcon | undefined;
  title: TextField | undefined;
  description: TextField | undefined;
};

@Component({
  selector: 'wl-extended-usps-section',
  standalone: true,
  templateUrl: './extended-usps-section.component.html',
  styleUrls: [
    './extended-usps-section.component.ed.scss',
    './extended-usps-section.component.essent.scss',
  ],
  imports: [
    CoreJssProxyModule,
    RichTextWrapperComponent,
    CrntButtonAlt,
    ExtendedUspComponent,
    NgClass,
    GenericLinkDirective,
    TrackLinkDirective,
  ],
})
export class ExtendedUspsSectionComponent {
  readonly uid = input.required<string>();
  readonly title = input.required<TextField>();
  readonly introduction = input.required<RichTextField>();
  readonly extendedUsps = input.required<ExtentedUsp[]>();
  readonly callToAction = input<LinkField>();
  readonly inverted = input<boolean>();

  readonly #fieldService = inject(FieldService);

  readonly showIntroduction = computed(() =>
    this.#fieldService.showTextField(this.introduction())
  );

  public readonly getExtendedUspClass = computed(() =>
    this.extendedUsps().length === 4 ? 'col-lg-3' : 'col-lg-4'
  );
}
